<template>
  <div class="kpt-detail-pane" :style="{ width: 'calc(100% - ' + paneWidth + 'px)'}">
    <router-view name="detail"></router-view>
  </div>
</template>
<script>
export default {
  computed: {
    paneWidth() {
      if (this.$store.state.user.settings.detailFullWidth) {
        return this.$store.state.user.settings.menuCollapsed ? '52' : '190';
      } 
      return this.$store.state.user.settings.menuCollapsed ? '467' : '605';
    }
  }
}
</script>
